/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
import { memo, useEffect, useRef, useState, useMemo } from 'react';
import { Box, maxWidth, minWidth } from '@mui/system';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { AspyreDatePicker as DatePicker } from 'components/common/InputFields';
import {
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Link as MuiLink,
    Stack,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useAuth from 'hooks/useAuth';
import useSnackbar from 'hooks/useSnackbar';
import MainCard from 'ui-component/cards/MainCard';
import { GLOBAL_DATE_FORMAT, PAYLOAD_DATE_TIME_FORMAT, LIST_LIMIT, SERVICE_ADDT_ANCILLARY } from 'constant';
import usePermission from 'hooks/usePermission';
import moment from 'moment';

import * as React from 'react';

import { Link } from 'react-router-dom';
import { encriptId } from 'utils/encription';
import ExportColumnData from 'components/ExportColumnData';
import NoData from 'components/reusable/NoData';
import { LocationDropdown, PatientDropdown, ServiceDropdown, StudentDropdown } from 'components/reusable/Dropdowns';
import { useLazyDownloadPdcGoalReportsQuery, useLazyGetPdcGoalReportsQuery } from 'store/services/reports/pdcGoalReport';
import { Info } from '@mui/icons-material';

import CTable, { CPagination } from 'components/CTable';
import AmountCard from 'components/reusable/AmountCard';
import { handleLocationChangev2 } from 'components/AsyncDropdown/onChangeHelper';
import _ from 'lodash';
import { Row } from './Row';
import { useGetSessionClassroomsQuery } from 'store/services/school/classroom';
import { useLazyGetTimeAuditReportsQuery, useLazyGetPrintTimeAuditReportsQuery } from 'store/services/reports/timeAuditReport';

const allyProps = {
    // flex: 1,
    sortable: false
};

const validationSchema = yup.object({
    location: yup.object().required('Location is Required').nullable(),
    startDate: yup.date().required('Start Date is required').typeError('Please enter a valid Start Date').nullable(),
    endDate: yup
        .date()
        .required('End Date is required')
        .typeError('Please enter a valid End Date')
        .nullable()
        .test('end-date-gte-start-date', 'End Date cannot be earlier than Start Date', function (endDate) {
            const { startDate } = this.parent;
            if (!startDate || !endDate) return true;
            return moment(new Date(endDate)).isSameOrAfter(moment(new Date(startDate)), 'day');
        })
});

const cols = (hasPermission) => [
    {
        ...allyProps,
        field: 'goal_id',
        headerName: 'Goal ID',
        width: 50
    },
    {
        ...allyProps,
        field: 'description',
        headerName: 'Goal Description',
        minWidth: 300
    },
    // {
    //     ...allyProps,
    //     field: 'location',
    //     headerName: 'Location',
    //     minWidth: 200
    // },

    {
        ...allyProps,
        field: 'status',
        headerName: 'Goal Status',
        minWidth: 150
    },

    {
        ...allyProps,
        field: 'total_success_count_of_month',
        headerName: 'Total Success Count',
        renderHeader: () => (
            <div
                style={{
                    color: '#424242',
                    fontWeight: 500,
                    lineHeight: 1.5,
                    whiteSpace: 'normal'
                }}
                className="MuiDataGrid-columnHeaderTitle"
            >
                Total Success Count of Month
            </div>
        ),
        minWidth: 160
    },
    {
        ...allyProps,
        field: 'total_attempt_count_of_month',
        headerName: 'Total Attempt Count',
        renderHeader: () => (
            <div
                style={{
                    color: '#424242',
                    fontWeight: 500,
                    lineHeight: 1.5,
                    whiteSpace: 'normal'
                }}
                className="MuiDataGrid-columnHeaderTitle"
            >
                Total Attempt Count of Month
            </div>
        ),
        minWidth: 160
    }
];

const TimeAuditReport = () => {
    const { user } = useAuth();
    const [page, setPage] = useState(1);
    const { hasPermission } = usePermission();
    const { notify } = useSnackbar();
    const studentRef = useRef();

    const [trigger, { data: reportData, isLoading: reportLoading, isFetching: reportFetching }] = useLazyGetTimeAuditReportsQuery();
    const [triggerPrint, { data: printData, isLoading: printLoading, isFetching: printFetching }] = useLazyGetPrintTimeAuditReportsQuery();
    const [downloadReport, { isLoading: reportDownloading }] = useLazyDownloadPdcGoalReportsQuery();

    const [printPreviewOpen, setPrintPreviewOpen] = useState(false);
    const [printPreview, setPrintPreview] = useState(null);

    const printPreviewUrl = useMemo(() => {
        if (!printPreview?.blob) return null;
        return URL.createObjectURL(
            new Blob([printPreview.blob], {
                type: printPreview?.type || 'application/pdf'
            })
        );
    }, [printPreview?.blob, printPreview?.type]);

    useEffect(() => {
        return () => {
            if (printPreviewUrl) URL.revokeObjectURL(printPreviewUrl);
        };
    }, [printPreviewUrl]);

    const formik = useFormik({
        initialValues: {
            location: null,
            classroom: null,
            startDate: null,
            services: null,
            endDate: null,
            patientName: null
        },
        validationSchema
    });

    const {
        data: classrooms,
        isLoading: classroomLoading,
        isFetching: classroomFetching
    } = useGetSessionClassroomsQuery(
        {
            filters: {
                ...(user?.client_id && { client_id: user.client_id }),
                ...(formik.values.location && { location_id: [formik.values.location.id] })
            }
        },
        { skip: !formik.values.location }
    );

    const [reports, setReports] = useState({
        fields: []
    });

    useEffect(() => {
        if (reportData && !reportLoading && !reportFetching) {
            setReports(reportData);
        }
    }, [reportData, reportLoading, reportFetching]);

    useEffect(() => {
        setPage(1);
    }, [formik.values]);

    const getIdArray = (val) => (val?.id ? [val.id] : []);

    const filters = {
        client_id: user?.client_id,
        start_date: moment(new Date(formik.values.startDate)).startOf('day').utc().format(PAYLOAD_DATE_TIME_FORMAT),
        end_date: moment(new Date(formik.values.endDate)).endOf('day').utc().format(PAYLOAD_DATE_TIME_FORMAT),

        location_ids: getIdArray(formik?.values?.location),
        classroom_id: formik?.values?.classroom?.id,
        service_ids: getIdArray(formik?.values?.services),
        patient_ids: getIdArray(formik?.values?.patientName),
        is_download: 0,
        order_by: 'date',
        order: 'DESC'
    };

    console.log('formik::', formik);

    const handleSearch = async () => {
        formik.handleSubmit();
        const errors = await formik.validateForm();

        if (Object.keys(errors).length === 0) {
            setPage(1);
            trigger({
                filters,
                pagination: {
                    current_page: 1
                }
            });
        }
    };

    const handlePrint = async () => {
        formik.handleSubmit();
        const errors = await formik.validateForm();

        if (Object.keys(errors).length === 0) {
            setPrintPreviewOpen(true);
            setPrintPreview(null);

            try {
                const res = await triggerPrint({
                    filters: {
                        ...filters,
                        picked_start_date: moment(new Date(formik.values.startDate)).startOf('day').format('MM-DD-YYYY'),
                        picked_end_date: moment(new Date(formik.values.endDate)).endOf('day').format('MM-DD-YYYY'),
                        is_print: 1
                    },
                    pagination: {
                        current_page: 1
                    }
                }).unwrap();

                setPrintPreview(res);
            } catch (error) {
                setPrintPreviewOpen(false);
                notify({
                    message: 'Error generating print preview',
                    severity: 'error'
                });
            }
        }
    };

    const handleClosePrintPreview = () => {
        setPrintPreviewOpen(false);
        setPrintPreview(null);
    };

    const handleDownloadPrintPreview = () => {
        if (!printPreviewUrl) return;

        const fileName = (printPreview?.fileName || 'time-audit-report.pdf').replace(/^"+|"+$/g, '');
        const link = document.createElement('a');
        link.href = printPreviewUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const handlePageChange = (_e, val) => {
        setPage(val);
        trigger({ filters, pagination: { current_page: val } });
    };

    const handleResetForm = () => {
        formik.resetForm();
        setReports({
            fields: []
        });
        // studentRef.current.handleReset();
    };

    const [exportData, setExportData] = useState(null);

    const handleClose = () => {
        setExportData(null);
    };

    const handleDownload = async () => {
        try {
            const res = await downloadReport({
                filters: {
                    ...filters,
                    picked_start_date: moment(new Date(formik.values.startDate)).startOf('day').format('MM-DD-YYYY'),
                    picked_end_date: moment(new Date(formik.values.endDate)).endOf('day').format('MM-DD-YYYY'),
                    action: 'download'
                }
            }).unwrap();

            setExportData(res);
        } catch (error) {
            notify({
                message: 'Error downloading report',
                severity: 'error'
            });
        }
    };

    const colProps = {
        width: 200,
        sortable: false,
        flex: 1
    };

    // Parse strings like "09:00 AM - 09:30 AM (Treatment)" to time ranges
    const extractTimeRanges = (timeStr) => {
        if (typeof timeStr !== 'string') return [];

        return [
            ...new Set(
                timeStr
                    .split(',')
                    .map((s) => s.trim())
                    .map((raw) => {
                        const match = raw.match(/(\d{1,2}:\d{2} [AP]M)\s*-\s*(\d{1,2}:\d{2} [AP]M)/);
                        if (!match) return null;

                        return JSON.stringify({
                            raw, // original string with label
                            strRaw: `${moment(match[1], 'hh:mm A').format('hh:mm A')} - ${moment(match[2], 'hh:mm A').format('hh:mm A')}`,
                            start: moment(match[1], 'hh:mm A'),
                            end: moment(match[2], 'hh:mm A')
                        });
                    })
                    .filter(Boolean)
            )
        ].map((item) => JSON.parse(item)); // turn JSON strings back into objects to dedupe
    };

    // Check if two time ranges overlap
    const doesOverlap = (a, b) => {
        return a.start.isBefore(b.end) && b.start.isBefore(a.end);
    };

    const sortRangesByStartTime = (ranges) => {
        return [...ranges].sort((a, b) => {
            const startA = moment(a.strRaw.split(' - ')[0], 'hh:mm A');
            const startB = moment(b.strRaw.split(' - ')[0], 'hh:mm A');
            return startA - startB;
        });
    };

    const cols = () => [
        {
            ...colProps,
            field: 'patient_name',
            headerName: 'Patient',

            align: 'left',
            headerAlign: 'left',
            renderCell: (params) => (
                <Typography variant="body1">
                    {hasPermission(['patient_edit']) && params.row?.patient_id ? (
                        <MuiLink
                            component={Link}
                            to={`/edit-patient/${encriptId(params.row.patient_id)}`}
                            underline="hover"
                            target="_blank"
                        >
                            <Typography noWrap>{params.value}</Typography>
                        </MuiLink>
                    ) : (
                        <Typography variant="body1">{params.value}</Typography>
                    )}
                </Typography>
            )
        },
        {
            ...colProps,
            field: 'date',
            headerName: 'Date',
            maxWidth: 90,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Box sx={{ position: 'relative' }}>
                    <Typography sx={{ paddingLeft: '8px' }} variant="body1">
                        {moment.utc(params.value).format(GLOBAL_DATE_FORMAT)}
                    </Typography>
                </Box>
            )
        },
        {
            ...colProps,

            align: 'center',
            headerAlign: 'center',
            field: 'location_name',
            headerName: 'Location'
        },
        {
            ...colProps,
            maxWidth: 200,
            align: 'center',
            headerAlign: 'center',
            field: 'classroom_name',
            headerName: 'Classroom Name'
        },
        {
            sortable: false,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            field: 'therapy_time',
            headerName: 'Therapy Time',
            minWidth: 250,
            renderCell: (params) => {
                const { st_therapy_time, pt_therapy_time, ot_therapy_time, st_session_time, pt_session_time, ot_session_time } = params.row;

                const therapyRanges = {
                    ST: extractTimeRanges(st_therapy_time),
                    PT: extractTimeRanges(pt_therapy_time),
                    OT: extractTimeRanges(ot_therapy_time)
                };

                const sessionRanges = {
                    ST: extractTimeRanges(st_session_time),
                    PT: extractTimeRanges(pt_session_time),
                    OT: extractTimeRanges(ot_session_time)
                };

                // helper to get timestamp from start time
                const getStartMs = (range) => {
                    if (!range?.start) return Infinity;
                    if (typeof moment !== 'undefined' && moment.isMoment(range.start)) {
                        return range.start.valueOf();
                    }
                    if (range.start instanceof Date) {
                        return range.start.getTime();
                    }
                    if (typeof range.start === 'string') {
                        const m = moment(range.start, 'hh:mm A', true);
                        if (m.isValid()) return m.valueOf();
                        const d = new Date(range.start);
                        if (!isNaN(d)) return d.getTime();
                    }
                    return Infinity;
                };

                // mismatch check
                const isMismatch = (label, therapyRange) => {
                    return !sessionRanges[label]?.some((sessionRange) => sessionRange.strRaw === therapyRange.strRaw);
                };

                // flatten all into one array with label info
                const allRanges = Object.entries(therapyRanges)
                    .flatMap(([label, ranges]) =>
                        (Array.isArray(ranges) ? ranges : []).map((range) => ({
                            label,
                            range,
                            startMs: getStartMs(range)
                        }))
                    )
                    .filter((item) => !!item.range?.raw) // remove empties
                    .sort((a, b) => a.startMs - b.startMs); // global sort by time

                if (allRanges.length === 0) {
                    return (
                        <Typography variant="body2" color="text.secondary">
                            --
                        </Typography>
                    );
                }

                return (
                    <Box sx={{ position: 'relative', pt: 1, pb: 1 }}>
                        <Box sx={{ maxHeight: 85, overflowY: 'auto', pr: 1 }}>
                            {allRanges.map(({ label, range }, idx) => {
                                const mismatch = isMismatch(label, range);
                                return (
                                    <Typography
                                        key={`${label}-therapy-${idx}`}
                                        variant="body2"
                                        sx={{ color: mismatch ? 'rgba(255, 115, 0, 0.97)' : 'inherit' }}
                                    >
                                        <strong>{label}:</strong> {range.raw}
                                    </Typography>
                                );
                            })}
                        </Box>
                    </Box>
                );
            }
        },
        {
            sortable: false,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            field: 'session_time',
            headerName: 'Session Time',
            minWidth: 250,
            renderCell: (params) => {
                const { st_therapy_time, pt_therapy_time, ot_therapy_time, st_session_time, pt_session_time, ot_session_time } = params.row;

                // Extract ranges
                const therapyRanges = {
                    ST: extractTimeRanges(st_therapy_time),
                    PT: extractTimeRanges(pt_therapy_time),
                    OT: extractTimeRanges(ot_therapy_time)
                };

                const sessionRanges = {
                    ST: extractTimeRanges(st_session_time),
                    PT: extractTimeRanges(pt_session_time),
                    OT: extractTimeRanges(ot_session_time)
                };

                // Check if the session time doesn't match therapy time
                const isMismatch = (label, sessionRange) => {
                    return !therapyRanges[label]?.some((therapyRange) => therapyRange.strRaw === sessionRange.strRaw);
                };

                const hasAny = Object.values(sessionRanges).some((arr) => arr.length);

                // Sort all ranges together by start time
                const sortAllRangesByStart = (rangesObj) => {
                    return Object.entries(rangesObj) // [[label, ranges], ...]
                        .flatMap(([label, ranges]) => ranges?.map((range) => ({ label, ...range })))
                        .sort((a, b) => moment(a.start) - moment(b.start));
                };

                const orderedRanges = sortAllRangesByStart(sessionRanges);

                let lastEndTime = null;

                return (
                    <Box sx={{ position: 'relative', pt: 1, pb: 1 }}>
                        {hasAny ? (
                            <Box sx={{ maxHeight: 85, overflowY: 'auto', pr: 1 }}>
                                {orderedRanges.map((rangeObj, idx) => {
                                    const mismatch = isMismatch(rangeObj.label, rangeObj);
                                    const overlap = lastEndTime && moment(rangeObj.start).isBefore(lastEndTime);

                                    // update memory for next iteration
                                    lastEndTime = rangeObj.end;

                                    return (
                                        <Typography
                                            key={`${rangeObj.label}-session-${idx}`}
                                            variant="body2"
                                            sx={{
                                                color: overlap ? 'red' : mismatch ? 'rgba(255, 115, 0, 0.97)' : 'inherit',
                                                fontWeight: overlap ? 'bolder' : 'inherit'
                                            }}
                                        >
                                            <strong>{rangeObj.label}:</strong>{' '}
                                            {`${moment(rangeObj.start).format('hh:mm A')} - ${moment(rangeObj.end).format('hh:mm A')}`}
                                        </Typography>
                                    );
                                })}
                            </Box>
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                --
                            </Typography>
                        )}
                    </Box>
                );
            }
        }
    ];

    const sortedClassrooms = useMemo(() => {
        return [...(classrooms?.fields || [])].sort((a, b) => a.location.name.localeCompare(b.location.name));
    }, [classrooms]);

    return (
        <MainCard
            title={
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography variant="h3">Time Tally Report</Typography>
                    <Tooltip
                        enterTouchDelay={0}
                        title="This report displays the therapy times of a patient for a given day and service, based on entries recorded in Therapy and Sessions."
                    >
                        <Info
                            sx={{
                                cursor: 'pointer',
                                height: 20,
                                width: 20,
                                color: (theme) => theme.palette.grey[400]
                            }}
                        />
                    </Tooltip>
                </Stack>
            }
            isLoading={reportDownloading || reportLoading || reportFetching}
        >
            <Grid mb={0} container spacing={2}>
                <Grid item sm={12} md={2}>
                    <LocationDropdown
                        required
                        sx={{ width: '100%' }}
                        filters={{ is_session: true }}
                        value={formik.values.location}
                        onChange={(value) => {
                            formik.setFieldValue('location', value);
                            formik.setFieldValue('classroom', null);
                        }}
                        error={formik.touched.location && Boolean(formik.errors.location)}
                        helperText={formik.touched.location && formik.errors.location}
                    />
                </Grid>

                <Grid item sm={12} md={2}>
                    <Autocomplete
                        loading={classroomLoading || classroomFetching}
                        options={sortedClassrooms}
                        groupBy={(opt) => opt?.location?.name}
                        getOptionLabel={(opt) => opt?.name || ''}
                        value={formik.values.classroom}
                        onChange={(_, val) => formik.setFieldValue('classroom', val)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Classroom"
                                error={formik.touched.classroom && Boolean(formik.errors.classroom)}
                                helperText={formik.touched.classroom && formik.errors.classroom}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <PatientDropdown
                        async
                        isLimitSearch
                        // ref={patientRef}
                        value={formik.values.patientName}
                        onChange={(v) => formik.setFieldValue('patientName', v)}
                        error={formik.touched.patientName && Boolean(formik.errors.patientName)}
                        helperText={formik.touched.patientName && formik.errors.patientName}
                    />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={2} lg={2}>
                    <ServiceDropdown
                        limitTags={2}
                        async
                        value={formik.values.services}
                        excludes={[SERVICE_PDC_ANCILLARY, SERVICE_ADDT_ANCILLARY]}
                        onChange={(v) => formik.setFieldValue('services', v)}
                        error={Boolean(formik.errors.services)}
                        helperText={formik.errors.services}
                    />
                </Grid> */}
                <Grid item sm={12} md={2}>
                    <DatePicker
                        required
                        label="Start Date"
                        inputFormat={GLOBAL_DATE_FORMAT}
                        value={formik.values.startDate}
                        onChange={(v) => {
                            formik.setFieldValue('startDate', v);
                            if (
                                v &&
                                formik.values.endDate &&
                                moment(new Date(formik.values.endDate)).isBefore(moment(new Date(v)), 'day')
                            ) {
                                formik.setFieldValue('endDate', v);
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                {...params}
                                required
                                variant="outlined"
                                label="Start Date"
                                error={Boolean(formik.errors.startDate)}
                                helperText={formik.errors.startDate}
                                inputProps={{ ...params.inputProps }}
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={12} md={2}>
                    <DatePicker
                        required
                        label="End Date"
                        minDate={formik.values.startDate}
                        inputFormat={GLOBAL_DATE_FORMAT}
                        value={formik.values.endDate}
                        onChange={(v) => formik.setFieldValue('endDate', v)}
                        renderInput={(params) => (
                            <TextField
                                fullWidth
                                required
                                {...params}
                                variant="outlined"
                                label="End Date"
                                error={Boolean(formik.errors.endDate)}
                                helperText={formik.errors.endDate}
                                inputProps={{ ...params.inputProps }}
                            />
                        )}
                    />
                </Grid>

                <Grid item>
                    <Stack direction="row" spacing={4} sx={{ minHeight: 50, alignItems: 'center' }}>
                        {/* Buttons */}
                        <Stack direction="row" spacing={2} sx={{ height: '100%', minHeight: 50 }}>
                            <Button onClick={handleSearch} variant="contained">
                                Search
                            </Button>
                            <Button onClick={handleResetForm} variant="contained">
                                Reset
                            </Button>
                            {reports?.fields?.length > 0 && (
                                <Button onClick={handlePrint} variant="contained">
                                    Print
                                </Button>
                            )}
                        </Stack>

                        {/* Legend */}
                        <Stack direction="column" spacing={1}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Box sx={{ width: 14, height: 14, bgcolor: 'red', borderRadius: '3px' }} />
                                <Typography variant="body2">Session Time Overlap</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Box sx={{ width: 14, height: 14, bgcolor: 'rgba(255, 115, 0, 0.97)', borderRadius: '3px' }} />
                                <Typography variant="body2">Therapy Session Mismatch</Typography>
                            </Box>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>

            {!reports?.fields?.length > 0 ? (
                <NoData title="No Data Found" />
            ) : (
                <Box
                    sx={{
                        marginTop: '15px'
                    }}
                >
                    <CTable
                        autoHeight
                        rowHeight={85}
                        rows={reports?.fields || []}
                        cols={cols()}
                        getRowId={(option) => option.id}
                        currentPage={page}
                        totalCount={reports?.fields?.[0]?.total_count}
                        countPerPage={LIST_LIMIT}
                        onPageChange={handlePageChange}
                    />
                </Box>
            )}

            <Dialog open={printPreviewOpen} onClose={handleClosePrintPreview} fullWidth maxWidth="lg">
                <DialogTitle sx={{ m: 0, p: 2, position: 'relative' }}>
                    Time Tally Report
                    <IconButton
                        aria-label="close"
                        onClick={handleClosePrintPreview}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500]
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            width: '100%',
                            height: '85vh',
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: 1
                        }}
                    >
                        {printLoading || printFetching ? (
                            <Box
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Typography variant="h4">Generating preview…</Typography>
                            </Box>
                        ) : printPreviewUrl ? (
                            <iframe
                                title="time-audit-report-preview"
                                src={`${printPreviewUrl}#toolbar=0`}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                }} // eslint-disable-line
                            />
                        ) : (
                            <Box
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Typography variant="h4">No preview available</Typography>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleDownloadPrintPreview}
                        disabled={!printPreviewUrl || printLoading || printFetching}
                    >
                        Download
                    </Button>
                    <Button variant="outlined" onClick={handleClosePrintPreview}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </MainCard>
    );
};

export default memo(TimeAuditReport);
